import { getUser, getUserInfo } from "features/auth/api/getUser";
import { getUserPermissions } from "features/auth/api/getUserPermissions";
import {
  LoginCredentialsDTO,
  loginTSM,
  loginWithEmailAndPassword,
  loginWithOTP,
} from "features/auth/api/login";
import { configureAuth } from "react-query-auth";
import storage from "utils/storage";

export interface User {
  email: string;
  id: string;
  username: string;
  firstname?: string;
  lastname?: string;
  fullName?: string;
  organizations?: any;
}

export type UserResponse = {
  accessToken: string;
  refreshToken?: string;
  user: User;
};

export type LoginResponse = {
  login: UserResponse;
};

function updateToken(accessToken: string) {
  storage.setToken(accessToken);
}

async function handleUserResponse(userResponse: UserResponse) {
  const { accessToken } = userResponse;
  updateToken(accessToken);
  const user = getUserInfo().then((value: any) => {
    const user = value?.data?.data as User;
    return user as User;
  });
  return user;
}

export async function loadPermission(user: User | string) {
  if (user) {
    const permissions = await getUserPermissions();
    if (permissions) {
      storage.setPermissions(permissions as string[]);
    }
  }
}

export async function loadPermissionMenu(user: User | string) {
  if (user) {
    const userInfo = await getUserInfo();
    if (userInfo) {
      const permissionMenu = userInfo?.data?.data?.organizations?.map(
        (e: any) => {
          return e?.application?.code;
        }
      );
      storage.setPermissionsMenu(permissionMenu as string[]);
    }
  }
}

async function userFn(): Promise<User | null> {
  if (storage.getToken()) {
    return getUserInfo()
      .then((value: any) => {
        const user = value?.data?.data as User;
        loadPermission(user);
        loadPermissionMenu(user);
        return user as User | any;
      })
      .catch((_reason: any) => {
        storage.clearToken();
        window.location.assign(window.location.origin as unknown as string);
        return null;
      });
  }
  return null;
}

async function loginFn(loginInput?: LoginCredentialsDTO) {
  const userResult = loginInput?.isOTP
    ? await loginWithOTP(loginInput)
    : await loginWithEmailAndPassword(loginInput);
  const user = await handleUserResponse(userResult as UserResponse);
  if (user) {
    loginTSM();
  }
  await loadPermission(user);
  await loadPermissionMenu(user);
  return user;
}

async function registerFn(data: any) {
  return null;
}

async function logoutFn() {
  storage.clearToken();
  window.location.assign(window.location.origin as unknown as string);
}

const authConfig = {
  userFn,
  loginFn,
  registerFn,
  logoutFn,
};

export const { AuthLoader, useUser, useLogin, useLogout } =
  configureAuth(authConfig);
